import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ComponentBase } from '../../_utils/component.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VoiceFlowService } from '../../_services/voice-flow.service';

@Component({
  selector: 'app-simple-card',
  templateUrl: './simple-card.component.html',
  styleUrls: ['./simple-card.component.scss'],
})
export class SimpleCardComponent extends ComponentBase implements OnInit {

  @Input()
  public title: string;
  @Input()
  public description: string;
  @Input()
  public descriptionTitle: string;
  @Input()
  public headerColor: string;
  @Input()
  public buttonText: string;
  @Input()
  public buttonIcon: boolean;
  @Input()
  public showCloseIcon: boolean;
  @Input()
  public simulationKey: string;
  @Input()
  public simulationKind: string;
  @Input()
  public subFlow: any;
  @Input()
  public allowUserExtraContextUpload: boolean;

  protected currentLang: string;
  protected subFlowForm: FormGroup;

  protected jobPosition = '';
  protected file: File | null = null;
  protected fileError = '';

  private readonly maxFileSizeBytes = 5 * 1024 * 1024;
  private readonly allowedFileTypes = ['application/pdf', 'image/'];

  constructor(
    public modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private voiceFlowService: VoiceFlowService,
  ) {
    super();
    this.descriptionTitle = '';
    this.headerColor = '';
    this.buttonIcon = true;
    this.showCloseIcon = false;
    this.simulationKey = '';
    this.simulationKind = 'DEFAULT';
    this.allowUserExtraContextUpload = false;

  }

  protected onFileChange = (event: Event): void => {
    this.fileError = '';
    this.file = null;
    const input = event.target as HTMLInputElement;
    const selected = input?.files?.[0];
    if (!selected) {
      return;
    }
    const isAllowedType = this.allowedFileTypes.some(type => selected.type.startsWith(type));
    if (!isAllowedType) {
      this.fileError = 'Invalid file type. Upload a PDF or image.';
      return;
    }
    if (selected.size > this.maxFileSizeBytes) {
      this.fileError = 'File is too large. Maximum size is 5MB.';
      return;
    }
    this.file = selected;
  };

  protected clearFile = (event: Event, input: HTMLInputElement): void => {
    event.stopPropagation();
    this.file = null;
    this.fileError = '';
    input.value = '';
  };

  async ngOnInit() {
    this.initSubFlowForm();
    this.description = this.addLineBreaks(this.description);
    this.currentLang = await this.getCurrentLang();
  }

  private initSubFlowForm = (): void => {
    if (this.simulationKind === 'CUSTOM') {
      for (const option of this.subFlow.options) {
        if (!option?.order) {
          option.order = 0;
        } else {
          option.order = Number(option.order);
        }
      }
      this.subFlowForm = this.formBuilder.group({
        attemptId: this.firebaseService.createPushId(),
        kind: 'CUSTOM',
        subFlowKey: ['', Validators.required],
      });
    } else {
      this.subFlowForm = this.formBuilder.group({
        kind: 'DEFAULT',
      });
    }
  };

  addLineBreaks(text: string): string {
    return text.replace(/\. /g, '.<br>');
  }

  async onButtonClick() {
    const payload = this.subFlowForm.getRawValue();
    if (payload.kind === 'CUSTOM') {
      const spinner = await this.openSpinner();
      await this.voiceFlowService.initVoiceFlowCustom(this.simulationKey, payload.attemptId, payload.subFlowKey, this.subFlow.apiKey);
      spinner.dismiss().then();
      this.modalCtrl.dismiss({
        data: {
          action: 'practiceButton',
          simulationKey: this.simulationKey,
          payload: {
            kind: payload.kind,
            attemptId: payload.attemptId,
            subFlowKey: payload.subFlowKey,
            jobPosition: this.jobPosition,
            file: this.file,
          },
        }
      });
    } else {
      this.modalCtrl.dismiss({
        data: {
          action: 'practiceButton',
          simulationKey: this.simulationKey,
          payload: { kind: payload.kind, jobPosition: this.jobPosition, file: this.file },
        }
      });
    }
  }

  onCloseButtonClick() {
    this.modalCtrl.dismiss();
  }

}
